import { useState } from "react";

const DOMAIN_OVERRIDES = {
  "google cloud": "cloud.google.com",
  "microsoft azure": "azure.microsoft.com",
  "xbox / microsoft": "xbox.com",
  "technology association of oregon": "techoregon.org",
  "oregon startup center": "oregonstartupcenter.org",
  "city of beaverton": "beavertonoregon.gov",
  "daimler truck north america": "daimlertruck.com",
  "portland general electric": "portlandgeneral.com",
  "energy trust of oregon": "energytrust.org",
  "nw natural": "nwnatural.com",
  "mercury": "mercury.com",
  "wieden+kennedy": "wk.com",
  "hugging face": "huggingface.co",
  "dbt labs": "getdbt.com",
  "palo alto networks": "paloaltonetworks.com",
  "unity technologies": "unity.com",
  "epic games": "epicgames.com",
  "chainlink labs": "chain.link",
  "polygon labs": "polygon.technology",
  "cambia health solutions": "cambiahealth.com",
  "prosper portland": "prosperportland.us",
  "umpqua bank": "umpquabank.com",
  "columbia sportswear": "columbia.com",
  opb: "opb.org",
  aws: "aws.amazon.com",
  xai: "x.ai",
  elevenlabs: "elevenlabs.io",
  "bloom ai": "bloom.ai",
  awesomesauce: "awesomesauce.io",
};

const domainFor = (s) => {
  if (s.website) return s.website.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  const key = s.name.trim().toLowerCase();
  return DOMAIN_OVERRIDES[key] || `${key.replace(/[^a-z0-9]/g, "")}.com`;
};

const initials = (name) => name.split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

const Logo = ({ sponsor, size }) => {
  const [failed, setFailed] = useState(false);
  const domain = domainFor(sponsor);
  const src =
    sponsor.logo_url ||
    `https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://${domain}&size=256`;
  const box = size === "lg" ? "h-16 w-16 text-base" : size === "md" ? "h-11 w-11 text-xs" : "h-9 w-9 text-[11px]";

  return failed ? (
    <span className={`${box} grid shrink-0 place-items-center rounded-xl bg-neutral-900 font-bold text-white`}>
      {initials(sponsor.name)}
    </span>
  ) : (
    <img
      src={src}
      alt={sponsor.name}
      onError={() => setFailed(true)}
      loading="lazy"
      className={`${box} shrink-0 rounded-xl object-contain`}
    />
  );
};

const Card = ({ sponsor }) => {
  const href = `https://${domainFor(sponsor)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid={`sponsor-card-${sponsor.name}`}
      title={`${sponsor.name} · ${sponsor.event_count} events`}
      className="flex items-center gap-3 rounded-xl border border-neutral-200 bg-white px-4 py-3 transition-shadow duration-200 hover:shadow-[0_6px_18px_rgba(0,0,0,0.09)]"
    >
      <Logo sponsor={sponsor} size="md" />
      <span className="min-w-0">
        <span className="block truncate text-sm font-semibold text-neutral-900">{sponsor.name}</span>
        <span className="block truncate text-xs text-neutral-500">
          {sponsor.tier === "Presenting" ? "Presenting partner · " : ""}
          {sponsor.blurb || `${sponsor.event_count} events`}
        </span>
      </span>
    </a>
  );
};

export const SponsorStrip = ({ sponsors }) => {
  if (!sponsors?.length) return null;
  return (
    <section className="border-t border-neutral-200" data-testid="sponsor-strip">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 md:py-20 lg:px-8">
        <h2 className="text-2xl font-bold tracking-tight text-neutral-900 sm:text-3xl">Partners behind the calendar</h2>
        <p className="mt-1 text-sm text-neutral-500 md:text-lg">
          Companies supporting Portland's community events, ordered by how much they show up.
        </p>
        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {sponsors.slice(0, 30).map((s) => (
            <Card key={s.name} sponsor={s} />
          ))}
        </div>
      </div>
    </section>
  );
};
